import { render, staticRenderFns } from "./Lansstyrelse.vue?vue&type=template&id=dcd25908&scoped=true&"
import script from "./Lansstyrelse.vue?vue&type=script&lang=js&"
export * from "./Lansstyrelse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd25908",
  null
  
)

export default component.exports